import { render, staticRenderFns } from "./LectureCard.vue?vue&type=template&id=0ea8dd0e&scoped=true&"
import script from "./LectureCard.vue?vue&type=script&lang=js&"
export * from "./LectureCard.vue?vue&type=script&lang=js&"
import style0 from "./LectureCard.vue?vue&type=style&index=0&id=0ea8dd0e&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ea8dd0e",
  null
  
)

export default component.exports